import { Collab } from "src/Actions/collab/types";

export const initialState = {
  presenceEvent: null,
  nativeAppConfig: null,
  nativeAppError: null,
  shouldUpdate: false,
  shouldTrainerUpdate: false,
  notificationStack: [],
  sessionToken: null
}

const collabReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case Collab.GET_CONFIG: {
      return {
        ...state
      }
    }
    case Collab.GET_CONFIG_SUCCESS: {
      let { nativeAppConfig } = action;
      return {
        ...state,
        nativeAppConfig
      }
    }
    case Collab.GET_CONFIG_FAILURE: {
      let { error } = action;
      return {
        ...state,
        nativeAppError: error
      }
    }
    default:
      return state;
  }
}

export default collabReducer;

